const getStyles = (theme) => ({
  largeModalBackdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
});

export default getStyles;
